import ReactMarkdown from "react-markdown"
import Moment from "react-moment"
import Link from "next/link"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import { getStrapiMedia } from "../../lib/media"
import { fetchData } from "../../utils/data"

const Article = ({ article, categories, recentArticles, relatedArticles }) => {
  let imageUrl = null
  if (article?.image) {
    imageUrl = getStrapiMedia(article.image)
  } else {
    imageUrl = "/blog-post-image-placeholder.jpeg"
  }

  const seo = {
    metaTitle: article?.og_title ?? article?.title,
    metaDescription: article?.og_description ?? article?.description,
    shareImage: article?.og_image ?? article?.image,
    article: true
  }
  if (article == null) {
    return <h1>Loading</h1>
  }

  return (
    <Layout categories={categories}>
      <Seo seo={seo} />
      <div className="section section--bg-world section--big">
        <div className="headline headline--centered">Blog</div>
      </div>
      <div className="section article__outer">
        <div className="">
          <div className="article wrapper wrapper--small">
            <div>
              <div id="banner" className="" data-src={imageUrl} data-srcset={imageUrl}>
                <img className="article__banner" src={imageUrl} />
                <div className="article__meta">
                  <Link as={`/category/${article?.category?.slug}`} href="/category/[slug]" style={{ textAlign: "center" }} passHref>
                    <div className="link link--category article__category">{article?.category?.name}</div>
                  </Link>
                </div>

                <h1 className="headline--centered">{article?.title}</h1>
              </div>
            </div>
            <div className="wrapper wrapper--small article__body">
              <div className="generic-content-container article__content" style={{ lineHeight: "29.2px" }}>
                <ReactMarkdown source={article?.content} escapeHtml={false} />
                <hr className="divider-small" />
                <div className="">
                  <div>
                    <p>Yazan: {article?.author?.name}</p>
                    <p>
                      <Moment format="D MMMM YYYY, dddd">{article?.created_at}</Moment>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {relatedArticles && (
            <div className="article__related">
              <h2 className="article-related__header">Buna benzer paylaşımlar</h2>
              <div className="article-related__inner">
                {relatedArticles.map(item => {
                  return (
                    <Link href={`/article/${item.slug}`} key={item.id} passHref>
                      <div
                        className="article-related"
                        style={{
                          backgroundImage: `url('${item.image ? getStrapiMedia(item.image) : "/blog-post-image-placeholder.jpeg"}')`
                        }}
                      >
                        <div>
                          <p className="article-related__title">{item.title}</p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" style={{ marginLeft: "1rem" }} viewBox="0 0 20 20" fill="currentColor">
                          <path
                            fillRule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    </Link>
                  )
                })}
              </div>
            </div>
          )}
        </div>

        <div className="article__sidebar">
          <div className="article__widget-list">
            <div className="article__widget">
              <h4 className="article-widget__title">Kategoriler</h4>

              <ul className="article-widget__list">
                {categories.map(category => {
                  return (
                    <Link key={category.id} href={"/category/" + category.slug} passHref>
                      <li className="link">{category.name.charAt(0).toUpperCase() + category.name.slice(1)}</li>
                    </Link>
                  )
                })}
              </ul>
            </div>

            <div className="article__widget">
              <h4 className="article-widget__title">Son Paylaşılanlar</h4>

              <ul className="article-widget__list">
                {recentArticles.map(recentArticle => {
                  return (
                    <Link key={recentArticle.id} href={"/article/" + recentArticle.slug} passHref>
                      <li className="link">{recentArticle.title.charAt(0).toUpperCase() + recentArticle.title.slice(1)}</li>
                    </Link>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export async function getStaticPaths() {
  const { articles } = fetchData()

  return {
    paths: articles.map(article => ({
      params: {
        slug: article.slug
      }
    })),
    fallback: true
  }
}

export async function getStaticProps({ params }) {
  const { articles } = fetchData()

  const recentArticles = articles

  const { categories } = fetchData()

  let relatedArticles = null

  if (articles[0].category) {
    relatedArticles = articles
  }

  return {
    props: {
      article: articles[0],
      categories,
      recentArticles,
      relatedArticles
    },
    revalidate: 1
  }
}

export default Article
